import type { ICTMOptions } from '../types/network';

import io from '@eab-pip/pi-io';
import f1 from '@eab-pip/pi-f1';

export class AuthorizationServant {
  /**
   * @returns central tenant management info uri, token
   */
  static async computeURI(url: string, opts: ICTMOptions) {
    opts = opts || {};

    // if there is a url and no endpoint_token
    //
    if (url && !opts.endpoint_token) {
      return url;
    }

    const [token, uri] = await Promise.all([this.__getCTMServerToken(opts), this.__getCTMServerURI(opts)]);

    return `${uri}${f1.read('/uri_suffix', '', opts)}?ctm_token=${token}`;
  }

  /**
   * @returns host of the server API to call
   */
  private static async __getCTMServerURI(opts: ICTMOptions) {
    return this.intermediateEndpoint(f1.read('/endpoint_uri', '', opts), '/access_url');
  }

  /**
   * @returns token of the server API to call
   */
  private static async __getCTMServerToken(opts: ICTMOptions) {
    const tokenCTM = await this.intermediateEndpoint(f1.read('/endpoint_token', '', opts), '/access_token');

    // pull out `Bearer` or `Token` if it exists
    return f1.nth(0, f1.last(f1.split(' ', tokenCTM)));
  }

  /**
   * @returns tokens and endpoint uris
   */
  static async intermediateEndpoint(uri: string, responseLens: string) {
    const failedURI = '/jwt/failed';

    return io
      .create('api')
      .include('api/hosting')
      .invoke(uri)
      .then((_) => f1.read(`/data/${responseLens}`, failedURI, _))
      .catch((_) => failedURI);
  }
}
